module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDExIDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTS4wNzkgMEwwIDE0bDEwLjUtNy4xODF6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/assets/play/play-icon.svg
// module id = 1686
// module chunks = 1 2 3